"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockOmniaResponse = void 0;
function mockOmniaResponse(overrides) {
    return {
        data: {},
        metadata: {
            timestamp: 1,
            ...overrides.metadata,
        },
        ...overrides,
    };
}
exports.mockOmniaResponse = mockOmniaResponse;
